import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { pageDirContext } from '../../App';

const Footer = () => {
  const { pageDir } = useContext(pageDirContext)
  
  const { t} = useTranslation();

  return (
    <footer className="bg-main text-white px-6 py-8">
      <div className="container mx-auto grid md:grid-cols-4 gap-8">
        
        {/* Logo and Company Information Section */}
        <div className={`md:col-span-2 mb-6 text-center ${pageDir === 'rtl' ? "md:text-right" : "md:text-left"}`}>
          <img 
            className="w-32 h-32 rounded-full mx-auto md:mx-0 mb-4 border-4 border-white"
            src="/assets/images/onmdm.jpg" 
            alt="ONMDM Logo" 
          />
          <h2 className="text-2xl font-semibold text-white mb-2">{t("ONMDM")}</h2>
          <p className="text-[#D1F7F3] mb-2">{t("L'Ordre National des Médecins Dentaires de Mauritanie (ONMDM) est une organisation professionnelle représentant les médecins dentaires en Mauritanie. Nous travaillons pour améliorer la qualité des soins dentaires et promouvoir la santé bucco-dentaire dans tout le pays.")}</p>
          <div className="text-[#D1F7F3] text-sm">
            <p>{t("Développé par Mohamed Salem Ould kbar")}</p>
            <p>{t("Téléphone:")} <a href="tel:+22236138613" className="hover:text-[#00e7c8]">36138613</a></p>
            <p>{t("Email:")} <a href="mailto:info@onmdm.com" className="hover:text-[#00e7c8]">info@onmdm.com</a></p>
          </div>
        </div>

        {/* Contact Section */}
        <div className={`mb-6 text-center ${pageDir === 'rtl' ? "md:text-right" : "md:text-left"}`}>
          <h2 className="text-xl font-semibold mb-2">{t("Contactez-nous")}</h2>
          <p>{t("Adresse:")} <span className="text-[#D1F7F3]">{t("Route de Nouadhibou, Nouakchott, Mauritanie")}</span></p>
          <p>{t("Email:")} <a href="mailto:info@onmdm.com" className="hover:text-[#00e7c8]">info@onmdm.com</a></p>
          <p>{t("Téléphone:")} <a href="tel:+22236478787" className="hover:text-[#00e7c8]">+222 36 47 87 87</a></p>
        </div>

        {/* Useful Links Section */}
        <div className={`mb-6 text-center ${pageDir === 'rtl' ? "md:text-right" : "md:text-left"}`}>
          <h2 className="text-xl font-semibold mb-2">{t("Liens Utiles")}</h2>
          <ul className="text-[#D1F7F3] space-y-2">
            <li><a href="/about" className="hover:text-[#00e7c8] transition-colors duration-300">{t("À propos de l'ONMDM")}</a></li>
            <li><a href="/services" className="hover:text-[#00e7c8] transition-colors duration-300">{t("Nos Services")}</a></li>
            <li><a href="/membership" className="hover:text-[#00e7c8] transition-colors duration-300">{t("Adhésion")}</a></li>
            <li><a href="/news" className="hover:text-[#00e7c8] transition-colors duration-300">{t("Actualités")}</a></li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div className={`mb-6 text-center ${pageDir === 'rtl' ? "md:text-right" : "md:text-left"}`}>
          <h2 className="text-xl font-semibold mb-2">{t("Suivez-Nous")}</h2>
          <div className="flex justify-center md:justify-start space-x-6">
            <a href="https://facebook.com/onmdm" target="_blank" rel="noopener noreferrer" className="text-[#D1F7F3] hover:text-[#00e7c8] transition-colors duration-300">
              <FaFacebook className="text-2xl" />
            </a>
            <a href="https://twitter.com/onmdm" target="_blank" rel="noopener noreferrer" className="text-[#D1F7F3] hover:text-[#00e7c8] transition-colors duration-300">
              <FaTwitter className="text-2xl" />
            </a>
            <a href="https://instagram.com/onmdm" target="_blank" rel="noopener noreferrer" className="text-[#D1F7F3] hover:text-[#00e7c8] transition-colors duration-300">
              <FaInstagram className="text-2xl" />
            </a>
            <a href="https://linkedin.com/company/onmdm" target="_blank" rel="noopener noreferrer" className="text-[#D1F7F3] hover:text-[#00e7c8] transition-colors duration-300">
              <FaLinkedin className="text-2xl" />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-[#00e7c8] pt-4 mt-8 text-center text-[#D1F7F3] text-sm">
        <p>&copy; {new Date().getFullYear()} {t("ONMDM. Tous droits réservés.")}</p>
      </div>
    </footer>
  );
};

export default Footer;
